




































import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
class SubmitResetButtonGroop extends Vue {
  @Prop({ type: String, default: "" }) model!: string;
}
export default SubmitResetButtonGroop;
